import React from 'react'


export default function LayoutOutside({children}){
    return(
        <div className="outside_content">
            { children }
        </div>
    )
}